// Modal fragment handler - guard against re-declaration during hot reload
if (typeof ModalFragmentHandler === 'undefined') {
  class ModalFragmentHandler {
    constructor() {
      this.init();
    }

    init() {
      // Check for fragment on page load
      this.checkFragment();
      
      // Listen for hash changes (back/forward navigation)
      window.addEventListener('hashchange', () => {
        this.checkFragment();
      });

      // Initialize all modals
      this.initializeModals();
    }

    checkFragment() {
      const fragment = window.location.hash.substring(1); // Remove the #
      
      if (!fragment) {
        // No fragment, close any open modals
        this.closeAllModals();
        return;
      }

      // Find modal with matching ID
      const modal = document.getElementById(fragment);

      if (modal && modal.classList.contains('modal')) {
        this.showModal(modal);
      }
    }

    showModal(modal) {
      modal.style.display = 'block';
      document.body.classList.add('overflow-hidden');
      
      // Show the modal overlay
      const overlay = document.querySelector('[data-modal-overlay]');
      if (overlay) {
        overlay.classList.add('is-active');
      }
      
      // Focus the close button for accessibility
      const closeButton = modal.querySelector('.modal__close-button');
      if (closeButton) {
        closeButton.focus();
      }
    }

    closeModal(modal) {
      modal.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
      
      // Hide the modal overlay
      const overlay = document.querySelector('[data-modal-overlay]');
      if (overlay) {
        overlay.classList.remove('is-active');
      }
      
      // Remove fragment from URL
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    closeAllModals() {
      const modals = document.querySelectorAll('.modal[style*="block"]');
      modals.forEach(modal => {
        modal.style.display = 'none';
      });
      document.body.classList.remove('overflow-hidden');
      
      // Hide the modal overlay
      const overlay = document.querySelector('[data-modal-overlay]');
      if (overlay) {
        overlay.classList.remove('is-active');
      }
    }

    initializeModals() {
      const modals = document.querySelectorAll('.modal');
      
      modals.forEach(modal => {
        // Handle close button click
        const closeButton = modal.querySelector('.modal__close-button');
        if (closeButton) {
          closeButton.addEventListener('click', () => {
            this.closeModal(modal);
          });
        }
        
        // Close modal when clicking outside
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            this.closeModal(modal);
          }
        });
      });
      
      // Close modal with Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const openModal = document.querySelector('.modal[style*="block"]');
          if (openModal) {
            this.closeModal(openModal);
          }
        }
      });
      
      // Close modal when clicking on overlay
      const overlay = document.querySelector('[data-modal-overlay]');
      if (overlay) {
        overlay.addEventListener('click', () => {
          const openModal = document.querySelector('.modal[style*="block"]');
          if (openModal) {
            this.closeModal(openModal);
          }
        });
      }
    }
  }

  // Expose to global scope for the guard to work
  window.ModalFragmentHandler = ModalFragmentHandler;

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ModalFragmentHandler();
    });
  } else {
    new ModalFragmentHandler();
  }
}